import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Scripting Flow**

HawkClient supports scripting at multiple levels to give you fine-grained control
over request execution and response handling.

Scripts are executed in a **well-defined sequence** during a request lifecycle.

---

### 🔄 **Execution Order**

When a request is triggered, scripts run in the following order:

1. **Collection Pre-Request Script**
   - Runs before anything else
   - Used for global setup (tokens, variables, auth logic)

2. **Folder Pre-Request Script**
   - Executes if the request belongs to a folder
   - Useful for folder-level shared logic

3. **Request Pre-Request Script**
   - Runs just before the request is sent
   - Ideal for modifying headers, body, or variables dynamically

4. **Request Execution**
   - The actual API request is sent

5. **Response Received**
   - Response data becomes available for scripting

6. **Collection Post-Response Script**
   - Executes immediately after receiving the response

7. **Folder Post-Response Script**
   - Runs after collection-level post script
   - Helpful for shared response handling across requests

8. **Request Post-Response Script**
   - Runs last
   - Ideal for cleanup, logging, or chaining workflows 

---

### 🧠 **Why This Matters**

Understanding the scripting flow allows you to:
- Share logic efficiently across collections and folders
- Avoid duplicated scripts
- Control variable precedence and overrides
- Build complex request chains and workflows

---

### 📌 **Quick Flow Summary**

\`\`\`text
Collection Pre-Request
   ↓
Folder Pre-Request
   ↓
Request Pre-Request
   ↓
Request Execution
   ↓
Response
   ↓
Collection Post-Response
   ↓
Folder Post-Response
   ↓
Request Post-Response
\`\`\`
`;

const ScriptSequence = () => {
    return (
        <MarkDownRenderer
            title="Scripting Flow"
            markDownText={markdownContent}
        />
    );
};

export default ScriptSequence;
